import Swiper from 'swiper';
import { Navigation, Autoplay } from 'swiper/modules';
import imagesLoaded from "imagesloaded";

function handleControlPosition(swiperContainer, controls) {
  const imgs = [...swiperContainer.querySelectorAll('img')];
  const sizes = imgs.map(img => img.offsetHeight);
  controls.style.top = `${Math.max(...sizes)}px`;
}

function handleControlsImageBottom(swiperContainer, controls) {

  const imgs = swiperContainer.querySelectorAll('img');
  imgs.forEach(img => {
    img.addEventListener('load', () => {
      handleControlPosition(swiperContainer, controls);
    });
  });

  window.addEventListener('load', () => handleControlPosition(swiperContainer, controls));
  window.addEventListener('resize', () => handleControlPosition(swiperContainer, controls));

}

function handleCustomAnimationSizing(swiper) {
  let yOffset = 0;

  swiper.slides.map((slide, idx) => {
    yOffset = idx === 0 ? 0 : yOffset + slide.offsetWidth;
    slide.style.transform = `translate3d(${yOffset * -1}px, 0, 0)`;
  });
}

function handleSizeMissingImages(swiperContainer) {

  imagesLoaded(swiperContainer, () => {
    if ( swiperContainer.querySelector('img') ) {
      const imgs = [...swiperContainer.querySelectorAll('img')];
      const sizes = imgs.map(img => img.offsetHeight);
      const missingImages = swiperContainer.querySelectorAll('.o-card-wide__missing-image');
      missingImages.forEach(el => {
        el.style.height = `${Math.max(...sizes)}px`;
      })
    }
  });
}

// function handleSizeFigures(swiperContainer) {
//   const figs = swiperContainer.querySelectorAll('figure');
//   figs.forEach(fig => {
//     fig.style.width = null;
//     const img = fig.querySelector('img');
//     fig.style.width = `${img.offsetWidth}px`;
//   });
// }

// function handleImageWidths(swiperContainer) {
//   handleSizeFigures(swiperContainer);

//   window.addEventListener('load', () => handleSizeFigures(swiperContainer));
//   window.addEventListener('resize', () => handleSizeFigures(swiperContainer));
// }


export default function initSwiper() {

  const swiperContainers = document.querySelectorAll('.js-swiper-container');

  swiperContainers.forEach((swiperContainer, idx) => {
    const swiperClass = `swiper-scc-${idx}`;
    const controls    = swiperContainer.querySelector('.js-swiper-controls');
    const slides      = swiperContainer.querySelectorAll('.swiper-slide');
    let swiperEl      = swiperContainer;

    const imgs = swiperEl.querySelectorAll('img');
    imgs.forEach(img => img.setAttribute('loading', 'eager'));

    if ( swiperContainer.classList.contains('js-swiper-controls-wrapper') ) {
      swiperEl = swiperContainer.querySelector('.swiper');
    }

    const options = {
      loop: false,
      slidesPerView: 'auto',
      watchOverflow: true,
      spaceBetween: 40,
      modules: []
    };

    if ( swiperEl.hasAttribute('data-slidesper') ) {
      options.slidesPerView = parseInt(swiperEl.getAttribute('data-slidesper'));
      options.observer = true;
    }

    if ( swiperEl.hasAttribute('data-loop') ) {
      options.loop = true;
    }

    if ( swiperEl.hasAttribute('data-notransition') ) {
      options.speed = 0;
    }

    if ( swiperEl.getAttribute('data-spacebetween') ) {
      options.spaceBetween = parseInt(swiperEl.getAttribute('data-spacebetween'));
    }

    if ( slides.length == 1 ) {
      swiperEl.classList.add( "disabled" );
    }

    if ( controls ) {
      const nxt = controls.querySelector('.js-swiper-next');
      const prv = controls.querySelector('.js-swiper-prev');

      options.modules.push(Navigation);
      options.navigation = {
        nextEl: nxt,
        prevEl: prv,
      };
    }

    if ( swiperEl.classList.contains('swiper-container--autoplay') ) {
      options.modules.push(Autoplay);
      options.autoplay = {
        enabled: true,
        delay: 4000
      };
      options.loop = true;
      options.spaceBetween = 0;
      options.watchOverflow = false;
    }

    if ( swiperEl.classList.contains('swiper-container--header') ) {
      options.autoplay = {
        enabled: true,
        delay: 4000,
        waitForTransition: false,
      };
      options.loop = false;
      options.virtualTranslate = true;
      options.watchSlidesProgress = true;
      options.effect = 'blucadetAnimation';
      options.on = {
        init: (swiper) => {
          handleCustomAnimationSizing(swiper);
          // const totalSlidesLen = swiper.slides.length;
          // console.log(totalSlidesLen);

          // swiperContainer.querySelector('.js-swiper-prev').addEventListener('click', () => {
          //   swiper.slidePrev();
          // });
          // swiperContainer.querySelector('.js-swiper-next').addEventListener('click', () => {
          //   swiper.slideNext();
          // });
        },
        imagesReady: (swiper) => {
          handleCustomAnimationSizing(swiper);
        },
        resize: (swiper) => {
          handleCustomAnimationSizing(swiper);
        },
      };
    }

    swiperEl.classList.add(swiperClass);

    const swiper = new Swiper(`.${swiperClass}`, options);

    swiper.init();

    if ( swiperEl.classList.contains('swiper-container--autoplay') ) {
      const toggle = swiperEl.querySelector('.js-swiper-autoplay-toggle');
      if ( toggle ) {
        if ( swiper.autoplay.running ) {
          toggle.classList.add('is-playing');
        }

        toggle.addEventListener('click', () => {
          if ( swiper.autoplay.running ) {
            toggle.classList.remove('is-playing');
            swiper.autoplay.stop();
          } else {
            toggle.classList.add('is-playing');
            swiper.autoplay.start();
          }
        });
      }
    }



    if ( controls && swiperContainer.classList.contains('js-swiper-controls-image-bottom') ) {
      handleControlsImageBottom(swiperContainer, controls, swiper);
    }

    const missingImages = swiperContainer.querySelector('.o-card-wide__missing-image');

    if (missingImages) {
      handleSizeMissingImages(swiperContainer);
      window.addEventListener('load', () => handleSizeMissingImages(swiperContainer));
      window.addEventListener('resize', () => handleSizeMissingImages(swiperContainer));
    }

    // if ( swiperContainer.classList.contains('js-swiper-size-figure') ) {
    //   imagesLoaded(swiperEl, () => {
    //     handleImageWidths(swiperContainer, swiper);
    //   });

    //   window.addEventListener('resize', () => {
    //     handleImageWidths(swiperContainer, swiper);
    //   });
    // }
  });
}
